<div *ngIf="!AccessAllowed && CompletedLoading">
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
</div>

<div *ngIf="AccessAllowed" class="p-3 flex flex-column flex-auto">
    <div class="text-900 font-medium text-xl mb-3"><h3>Package Booking Fees</h3></div>

    <div class="surface-card p-4 shadow-2 border-round">
        <div class="grid formgrid">

            <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3" style="width:100%">
                <span class="pi pi-info-circle" style="margin-right:2px;"></span>
                Assign a booking fee to each package. When a booking is made for a package, the assigned fee will be applied. If no fee is assigned, the default booking fee will be used.
            </p>

            <p-table #pkgTable
                [value]="packages"
                sortField="name"
                [paginator]="true"
                [rows]="10"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                [rowsPerPageOptions]="[10,25,50]"
                responsiveLayout="scroll"
                style="width:100%">

                <ng-template pTemplate="header">
                    <tr>
                        <th style="width:220px;">Booking Fee</th>
                        <th pSortableColumn="name">Package <p-sortIcon field="name"></p-sortIcon></th>
                        <th style="width:300px;">Change</th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-pkg>
                    <tr>
                        <td>
                            <span *ngIf="pkg._bookingfeeid"
                                  style="display:inline-flex; align-items:center; gap:6px; padding:3px 10px; border-radius:12px; font-size:0.8rem; font-weight:500; cursor:default;"
                                  [style.border]="'1px solid ' + getFeeColour(pkg._bookingfeeid)"
                                  [style.background]="getFeeColour(pkg._bookingfeeid) + '22'">
                                <span style="display:inline-block; width:10px; height:10px; border-radius:50%;"
                                      [style.background-color]="getFeeColour(pkg._bookingfeeid)"></span>
                                <span>{{ getFeeName(pkg._bookingfeeid) }}</span>
                            </span>
                            <span *ngIf="!pkg._bookingfeeid" class="text-500 text-sm">None</span>
                        </td>
                        <td>{{ pkg.name }}</td>
                        <td>
                            <p-dropdown
                                [options]="feeDropdownOptions"
                                [(ngModel)]="pkg._bookingfeeid"
                                optionLabel="label"
                                optionValue="value"
                                placeholder="No booking fee"
                                [showClear]="true"
                                [style]="{'width':'280px'}"
                                (onChange)="onFeeChange(pkg)">
                            </p-dropdown>
                        </td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="3" class="text-center text-600 py-4">No packages found.</td>
                    </tr>
                </ng-template>

            </p-table>

        </div>
    </div>
</div>
